// extracted by mini-css-extract-plugin
export default {"wrapprer":"DefaultLayout_wrapprer__vSAE6","body":"DefaultLayout_body__7I0OR","mobileMenuButton":"DefaultLayout_mobileMenuButton__fhGDe"};